import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { UserRoleEnum } from "src/app/shared/models/enums/user-role.enum";
import { FocusPayDevice } from "src/app/shared/models/FocusPay/FocusPayDevice.model";

@Component({
	selector: "app-devices",
	templateUrl: "./devices.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class DevicesComponent implements OnInit {
	deviceList: FocusPayDevice[];

	deviceSelected: FocusPayDevice;

	constructor(public app: AppService, public focuslink: FocuslinkService, public userService: UserService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		if (this.userService.userSubscription.value.role >= UserRoleEnum.SUPERADMIN) {
			this.getDeviceList();
		}
		if (
			this.userService.userSubscription.value.role === UserRoleEnum.DEALERADMIN ||
			this.userService.userSubscription.value.role === UserRoleEnum.DEALERUSER
		) {
			this.getDeviceList(undefined, this.userService.userSubscription.value.dealerKey);
		}
		if (
			this.userService.userSubscription.value.role === UserRoleEnum.VENUEADMIN ||
			this.userService.userSubscription.value.role === UserRoleEnum.VENUEUSER
		) {
			this.getDeviceList(this.venueService.subscriptionVenue.value.key);
		}
	}

	async addDevice() {
		this.deviceSelected = new FocusPayDevice({
			newDevice: true,
		});
	}

	async onDelete(device: FocusPayDevice) {
		this.deviceList.splice(
			this.deviceList.findIndex((i) => i.key === device.key),
			1
		);
		this.deviceList = [...this.deviceList];
	}

	onSave(device: FocusPayDevice) {
		if (device.newDevice) {
			this.deviceList.push(device);
		} else {
			this.deviceList[this.deviceList.findIndex((i) => i.key === device.key)] = device;
		}
		this.deviceList = [...this.deviceList];
	}

	async getDeviceList(venueKey?: number, dealerKey?: string) {
		let resp;
		if (venueKey) {
			resp = await this.focuslink.focusPayDeviceGet(venueKey);
		} else if (dealerKey) {
			resp = await this.focuslink.focusPayDeviceGet(undefined, dealerKey);
		} else {
			resp = await this.focuslink.focusPayDeviceGet();
		}

		this.deviceList = resp.map((i) => {
			const d = new FocusPayDevice(i);

			if (d.venueKey) {
				const venueName = this.userService.userVenues.value.find((i) => i.venueKey === d.venueKey)?.venueName;
				d.venueAssignment = venueName ? `${d.venueKey} - ${venueName}` : `${d.venueKey}`;
			}

			d.deviceId = `${d.type}-${d.key}`;
			return d;
		});
	}
}
